import http from '../utils/http';

const houseApi = {
    /**
     * 获取门店下拉列表
     */
    getStoreSelectList(options = {}, config = {}) {
        return http.get('/storeRoom/getStoreSelectList', options, {
            ...config
        })
    },
    /**
     * 获取门店下房间列表
     */
    getRoomSelectList(options = {}, config = {}) {
        return http.get('/storeRoom/getRoomSelectList', options, {
            ...config
        })
    },
    /**
     * 分页获取门店房间列表
     */
    getRoomByPage(options = {}, config = {}) {
        return http.get('/storeRoom/getRoomByPage', options, {
            ...config
        })
    },
    /**
     * 新增门店
     */
    addRoom(options = {}, config = {}) {
        return http.post('/storeRoom/addRoom', options, {
            ...config
        })
    },
    /**
     * 修改门店
     */
    updateRoom(options = {}, config = {}) {
        return http.post('/storeRoom/updateRoom', options, {
            ...config
        })
    },
    /**
     * 删除门店
     */
    deleteRoom(roomId='') {
        return http.delete(`/storeRoom/deleteRoom?roomId=${roomId}`)
    }
}

export default houseApi;
